import { atomFamily } from 'jotai-family';
import { atomWithDefault, loadable } from 'jotai/utils';
import { ICompanyMilestoneDataMode } from '../../data-models/company-milestone.data-model';
import { fetchCompanyMilestones } from '../queries/MaggieMilestonesQueries';

type MilestonesValue = ICompanyMilestoneDataMode[] | null | Promise<ICompanyMilestoneDataMode[] | null>;

/**
 * The default fetches all milestones for the company. Returns `null` (without
 * fetching) when `companyId <= 0` — `MilestonesSection` calls this atom
 * unconditionally and `selectedCompanyIdProfileAtom` defaults to `-1`.
 *
 * On fetch failure the atom resolves to `null` (rather than rejecting the
 * promise) so the consumer's suspense/error boundary is never triggered.
 *
 * Consumers using `useAtomValue` will suspend on first read; callers needing
 * a non-suspending or sync peek should use {@link milestonesByCompanyStateLoadableJ}.
 */
export const milestonesByCompanyStateJ = atomFamily((companyId: number) =>
  atomWithDefault<MilestonesValue>(async () => {
    if (companyId <= 0) {
      return null;
    }
    try {
      return await fetchCompanyMilestones(companyId);
    } catch (err) {
      console.error(err);
      return null;
    }
  })
);

export const milestonesByCompanyStateLoadableJ = atomFamily((companyId: number) =>
  loadable(milestonesByCompanyStateJ(companyId))
);
